// extracted by mini-css-extract-plugin
module.exports = {"Map":"MapComp_Map__1awda"};